import { Language } from "../../model/Language.js";
import { Pano } from "../Pano.js";
import { BaseControl, ControlPosition } from "./BaseControl.js";

export class ControlLanguage extends BaseControl {
    constructor(pano: Pano) {
        super(pano, ControlPosition.RIGHT);

        this.element.classList.add("control-button", "langauge");
        this.element.innerHTML = `
        <div class="control-button-icon">${Language.current === "de" ? "EN" : "DE"}</div>
        `;

        this.element.addEventListener("click", (e) => {
            const url = e5.Url.params.set("lang", Language.current === "de" ? "en" : "de");
            window.open(url, "_self");
        });
    }
}